import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Eyebrow, Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "What is your Minimum Order Quantity (MOQ)?",
    a: "For spices, our standard MOQ is 1 metric ton. For cold pressed oils it starts at 250–500 litres depending on the variant. Trial orders and mixed-container loads can be arranged for new buyers.",
  },
  {
    q: "Which export documents do you provide?",
    a: "Every shipment includes a certificate of analysis, phytosanitary certificate, fumigation certificate, certificate of origin and packing list. We handle FSSAI, customs and port documentation end-to-end.",
  },
  {
    q: "Do you offer private labeling for the oils?",
    a: "Yes. Groundnut, sunflower, sesame, flaxseed and olive oils can be bottled under your own brand in 250ml to 15L formats, with your label design and market-specific compliance text.",
  },
  {
    q: "Can I get samples before placing a bulk order?",
    a: "Absolutely. We dispatch 200–500g samples of any commodity via express courier within 3–5 working days. Sample cost is adjusted against your first confirmed order.",
  },
  {
    q: "What are your shipping lead times?",
    a: "Confirmed orders are typically loaded within 10–14 days. Transit time depends on destination — roughly 12–18 days to the Gulf, 20–28 days to Europe and 25–35 days to the Americas.",
  },
  {
    q: "Which ports do you ship from?",
    a: "Most spice containers load at Nhava Sheva (Mumbai) or Chennai, and oil consignments ship from Chennai. Samples and urgent small lots go by air from Hyderabad. We'll always confirm the fastest routing for your destination.",
  },
  {
    q: "What payment terms do you support for international buyers?",
    a: "Standard terms are 30% advance by T/T with the balance against bill of lading copies. For established buyers we work with irrevocable LC at sight. All terms are confirmed in the proforma invoice before production begins.",
  },
  {
    q: "Can I buy smaller bottles for my home?",
    a: "Yes! Every Tsugiva oil is available in 500ml, 1L and 5L home packs. Email info@tsugivainternational.com with your city and quantity, and we'll personally confirm availability and delivery.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-sand py-20 md:py-28">
      <div className="mx-auto max-w-3xl px-4 sm:px-8">
        <Reveal className="text-center">
          <Eyebrow>Good to Know</Eyebrow>
          <h2 className="mt-3 font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl lg:text-5xl">
            Frequently asked questions
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <Accordion type="single" collapsible className="mt-12 space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="rounded-2xl border border-stone2 bg-white px-6 transition-colors duration-300 data-[state=open]:border-gold"
              >
                <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="py-5 text-left font-serif text-base font-semibold text-ink hover:no-underline sm:text-lg">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-smoke sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
